import { Extension } from "@tiptap/core";
import useAbsoluteWindowStore from "../../../stores/absoluteWindowStore";

export const LinkShortcut = Extension.create({
    name: "linkShortcut",

    addKeyboardShortcuts() {
        return {
            "Mod-l": () => {
                const { editor } = this;
                useAbsoluteWindowStore.getState().showTextMenu(editor);

                return true; // Prevent default
            },
        };
    },
});
